// extracted by mini-css-extract-plugin
module.exports = {"loginLogo":"login_loginLogo_3tlFP","loginButton":"login_loginButton_2JpdI","alertColor":"login_alertColor_5cY_w","form":"login_form_2sJPa"};